import { Injectable, signal } from '@angular/core';
import { ShiftAssignmentResponse } from '@interfaces/shift/shift-assignment-response';

@Injectable({
  providedIn: 'root',
})
export class SecurityAssignmentService {
  securityAssignments = signal<ShiftAssignmentResponse[]>([]);

  setSecurityAssignments(securityAssignments: ShiftAssignmentResponse[]) {
    this.securityAssignments.set(securityAssignments);
  }
}
